import './i18n';
import './styles/global.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from './utils/Seo';
import LandingPage from './components/LandingPage';
import ClientOffer from './components/ClientOffer';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import FilmsPage from './components/FilmsPage';

function AppContent() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/offers" element={<Navigate to="/" replace />} />
        <Route path="/client/:id" element={<ClientOffer />} />
  <Route path="/films" element={<FilmsPage />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
